<script>
import scribbleBonplan from '@app/assets/img/scribbles/cyan_heart_cute_face.png';
import scribbleSuper from '@app/assets/img/scribbles/cyan_eight_pointed_star_happy.png';
import scribbleIdee from '@app/assets/img/scribbles/cyan_five_petal_flower_large_eyes.png';
import scribbleReflexion from '@app/assets/img/scribbles/cyan_semicircle_sleepy_eyes.png';
import scribbleEcriture from '@app/assets/img/scribbles/cyan_bean_cute_face.png';

import decoStar from '@app/assets/img/scribbles/cyan_star_cute_face.png';
import decoCircle from '@app/assets/img/scribbles/cyan_circle_happy_smile.png';
import decoCrown from '@app/assets/img/scribbles/cyan_crown_three_peaks.png';

const STATES = [
  { key: 'bonplan', src: scribbleBonplan },
  { key: 'super', src: scribbleSuper },
  { key: 'idee', src: scribbleIdee },
  { key: 'reflexion', src: scribbleReflexion },
  { key: 'ecriture', src: scribbleEcriture },
];

// Preload all images
[...STATES.map((s) => s.src), decoStar, decoCircle, decoCrown]
  .forEach((src) => { (new Image()).src = src; });

export default {
  data: () => ({
    index: 1,
    decoStar,
    decoCircle,
    decoCrown,
  }),
  computed: {
    current() {
      return STATES[this.index];
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
    const timer = setInterval(() => {
      let random;
      do {
        random = Math.floor(Math.random() * STATES.length);
      } while (random === this.index);
      this.index = random;
    }, 3500);
    this.$on('hook:destroyed', () => {
      clearInterval(timer);
      if (this.$el.parentElement === document.body) {
        document.body.removeChild(this.$el);
      }
    });
  },
};
</script>

<template>
  <div class="ailoader">
    <div class="ailoader_deco ailoader_deco--1">
      <img :src="decoStar" alt="">
    </div>
    <div class="ailoader_deco ailoader_deco--2">
      <img :src="decoCircle" alt="">
    </div>
    <div class="ailoader_deco ailoader_deco--3">
      <img :src="decoCrown" alt="">
    </div>

    <div class="ailoader_content">
      <div class="ailoader_scribble">
        <transition name="scribble" mode="out-in">
          <img
            :src="current.src"
            :alt="current.key"
            :key="current.key"
          >
        </transition>
      </div>

      <div class="ailoader_dots">
        <span />
        <span />
        <span />
      </div>

      <transition name="msg" mode="out-in">
        <p
          class="ailoader_msg"
          :key="current.key"
          v-t="`ai_assistant.load_messages.${current.key}`"
        />
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ailoader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(7, 42, 37, 0.92);
  backdrop-filter: blur(8px);
  animation: ailoader-fadein 0.3s ease-out;

  &_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  &_scribble {
    animation: ailoader-float 3s ease-in-out infinite;

    img {
      width: 140px;
      height: 140px;
      object-fit: contain;
      filter: drop-shadow(0 8px 32px rgba(0, 255, 200, 0.2));
    }
  }

  &_dots {
    display: flex;
    gap: 8px;

    span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: rgba(0, 255, 200, 0.6);
      animation: ailoader-bounce 1.4s ease-in-out infinite;

      &:nth-child(2) {
        animation-delay: 0.16s;
      }

      &:nth-child(3) {
        animation-delay: 0.32s;
      }
    }
  }

  &_msg {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.15rem;
    font-weight: 500;
    text-align: center;
    max-width: 400px;
    line-height: 1.5;
  }

  &_deco {
    position: absolute;
    pointer-events: none;
    opacity: 0.08;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &--1 {
      width: 90px;
      top: 12%;
      right: 10%;
      animation: ailoader-drift 8s ease-in-out infinite;
    }

    &--2 {
      width: 70px;
      bottom: 15%;
      left: 8%;
      animation: ailoader-drift 10s ease-in-out infinite reverse;
    }

    &--3 {
      width: 60px;
      top: 20%;
      left: 15%;
      animation: ailoader-drift 12s ease-in-out infinite 2s;
    }
  }
}

@keyframes ailoader-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ailoader-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes ailoader-bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes ailoader-drift {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(8deg);
  }
}

.scribble-enter-active,
.scribble-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.scribble-enter {
  opacity: 0;
  transform: scale(0.75) rotate(8deg);
}

.scribble-leave-to {
  opacity: 0;
  transform: scale(0.75) rotate(-8deg);
}

.msg-enter-active,
.msg-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.msg-enter {
  opacity: 0;
  transform: translateY(6px);
}

.msg-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
